import ComponentManager from '@/Management/ComponentManager';

import ControlFactory from '@/Factories/ControlFactory';
import InlineEditingGridViewModel from '@/ViewModels/Controls/InlineEditingGridViewModel';
import InlineEditingGrid from '@/Controls/InlineEditingGrid';
import { IGridControlFactory, IInlineEditingGridFactoryConstructorParameter } from '#/DefaultViewExtensionInterfaces';

export default class InlineEditingGridFactory extends ControlFactory implements IGridControlFactory {

    public controlDomElement: JQuery;

    /**
     * @override
     */
    public viewModel: InlineEditingGridViewModel;

    private InlineEditingGridViewModel = ComponentManager.getViewModel<typeof InlineEditingGridViewModel>('InlineEditingGridViewModel');
    private InlineEditingGrid = ComponentManager.getControl<typeof InlineEditingGrid>('InlineEditingGrid');

    constructor(private params: IInlineEditingGridFactoryConstructorParameter) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.controlDomElement != null) {
            return this.controlDomElement;
        }

        this.viewModel = new this.InlineEditingGridViewModel({
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            detailViewItem: this.detailViewItem,
            detailViewContext: this.context,
            isEnabled: this.isEnabled,
            invalidationText: this.invalidationText,
            isValid: this.isValid,
            excludedMembers: this.params.excludedMembers?.split(','),
            visibleMembers: this.params.visibleMembers?.split(','),
            isDisplayed: this.isDisplayed,
        });

        this.registerObservableValidation(this.viewModel.dataSource);

        this.control = new this.InlineEditingGrid(this.viewModel, $("<div>"));

        let tuple = this.control.getTuple();
        this.controlDomElement = tuple.control;

        return this.controlDomElement;
    }

    public getContainerPostfix(): KnockoutObservable<string> {
        return this.defineComputed(() => {
            if (this.viewModel.isDisposed)
                return '';
            
            const dataSource = this.viewModel.dataSource();
            return dataSource.length.toString();
        });
    }
}

ComponentManager.setFactory('InlineEditingGridFactory', InlineEditingGridFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('InlineEditingGrid', InlineEditingGridFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');